import * as React from 'react';
import { getCurrencyHintText } from '../../lib/currencyHelpers';
import { FeeCurrency } from '../../CommonInterfaces';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';

const styles = {
  textFieldStyles: {
    display: 'block',
    fontSize: 14,
    maxWidth: 64,
  },
  errorIconStyles: {
    width: 18,
    height: 18,
    right: 0,
    top: -31,
  },
};

interface PriceFieldProps {
  'key': any;
  'name': string;
  'value': string;
  'data-error-key': string;
  'errorText': string;
  'style'?: any;
  'labelText'?: string;
  'disabled': boolean;
  'feeCurrency'?: FeeCurrency;
  onChange(event);
}

interface PriceFieldState {
  showErrorTooltip: boolean;
}

class PriceField extends React.Component<PriceFieldProps, PriceFieldState> {
  constructor(props) {
    super(props);

    this.state = {
      showErrorTooltip: false,
    };
  }

  public render() {
    const { style, labelText, disabled, errorText, name, value, feeCurrency, ...otherProps } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        <FormControl variant="standard" disabled={disabled}>
          <InputLabel htmlFor={name}>{labelText}</InputLabel>
          <Input
            id={name}
            name={name}
            data-testid={name}
            value={value}
            onChange={otherProps.onChange}
            type="number"
            onWheel={(event) => {
              const target = event.target as HTMLInputElement;
              target.blur();
            }}
            inputProps={{ min: 0, step: 'any' }}
          />
          <FormHelperText>{getCurrencyHintText(feeCurrency)}</FormHelperText>
          {errorText && <FormHelperText error={true}>{errorText}</FormHelperText>}
        </FormControl>
      </div>
    );
  }

  private toggleErrorTooltip = (event) => {
    this.setState({ showErrorTooltip: event.type === 'mouseover' });
  };
}

export default PriceField;
